import React from 'react';

import Bakeliteinje from './Bakeliteinje';
import Bakelitepump from './Bakelitepump';
import Tbakelites from './Tbakelites';



const Tseriesbak = () => {
    return (
        <div>
      <Bakeliteinje />
            <Bakelitepump />
            <Tbakelites />

        </div>
    );
};
export default Tseriesbak;
